import React from "react";
import styles from "./WordButton.module.css";
import { Toggle } from "../ui/toggle";

import { GameStatusContext } from "../../providers/GameStatus";

function WordButton({ word, fullCandidateSize }) {
    const { guessCandidate, setGuessCandidate } =
        React.useContext(GameStatusContext);
    const [isSelected, setIsSelected] = React.useState(
        !!guessCandidate.includes(word)
    );

    const isCandidateListFull = guessCandidate.length === fullCandidateSize;

    React.useEffect(() => {
        setIsSelected(!!guessCandidate.includes(word));
    }, [guessCandidate, word]);

    function flipSelection() {
        if (isSelected) {
            // remove from candidateGuess
            const updatedGuessCandidate = guessCandidate.filter((w) => {
                return w !== word;
            });
            setGuessCandidate(updatedGuessCandidate);
            // set state to *not* selected
            setIsSelected(false);
        } else {
            // check if the candidate array is full
            if (!isCandidateListFull) {
                // add to candidateGuess array
                setGuessCandidate([...guessCandidate, word]);
                // set state to *selected*
                setIsSelected(true);
            }
        }
    }

    return (
        <Toggle
            className={styles.tile}
            variant="outline"
            pressed={isSelected}
            onClick={flipSelection}
            aria-label={`Select ${word}`}
        >
            <span className="text-center leading-tight break-words hyphens-auto">
                {word}
            </span>
        </Toggle>
    );
}

export default WordButton;
